import {request} from "../../../utils/apiUtils";
import {URL_API} from "../../../url.config";

let CustomerCareController = {
    getListCustomerCare: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-qlts/customer-care/list`,
            method: 'POST',
            body: {
                ...payload,
            },
        }, callback)
    },
    createCustomerCare: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-qlts/customer-care/create`,
            method: 'POST',
            body: {
                ...payload,
            },
        }, callback);
    },
}

export default CustomerCareController
